/**
 * Transform Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Shuffle } from 'lucide-react';
import styles from './Nodes.module.css';

export const TransformNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.transformNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#f97316' }}>
          <Shuffle size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Transform'}</span>
          {data.transformType && (
            <span className={styles.nodeSubtitle}>{data.transformType}</span>
          )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
      />
    </div>
  );
});

TransformNode.displayName = 'TransformNode';
